"use strict";
/*
 * Assume open-dialog buttons have a data-dialog-id attribute with the id of the dialog to open and the class open-dialog.
 *
 * Assume dialog elements have the class wwb-dialog and the corresponding id.
 *
 * Assume dialog elements have a close button with the class dialog__close.
 *
 * Assume dialog elements have a dialog__inner element.
 *
 * Enqueue 'wwb-dialog' script
 * */
for (const closeButton of document.querySelectorAll('button.dialog__close')) {
    const dialogElement = closeButton.closest('dialog');
    if (!dialogElement) {
        console.error('No dialog element found.');
        continue;
    }
    closeButton.addEventListener('click', () => {
        dialogElement.close();
    });
}
for (const openButton of document.querySelectorAll('button.open-dialog')) {
    const dialogElement = document.querySelector(`dialog#${openButton.dataset.dialogId}`);
    if (!dialogElement) {
        console.error(`No dialog element with id ${openButton.dataset.dialogId} found.`);
        continue;
    }
    openButton.addEventListener('click', () => {
        dialogElement.showModal();
    });
}
for (const dialog of document.querySelectorAll('dialog.wwb-dialog')) {
    /*	dialog.addEventListener('cancel', () => {
            dialog.close();
        });*/
    // Close dialog when clicking outside of it
    dialog.addEventListener('click', (event) => {
        if (event.target instanceof HTMLElement &&
            !event.target.closest('.dialog__inner')) {
            dialog.close();
        }
    });
}
